import React from 'react';
import styled, { css } from 'styled-components';

import { colors } from '@/constants/theme';
import { media } from '@/utils/mixin';
import { handleScrollToDomElement } from '@/utils/scroll';

interface Props {
  contents: string[][];
}

function ListOfContents({ contents }: Props) {
  return (
    <Component>
      <ContentsList>
        {contents.map((content, index) => (
          <ContentsListItem
            key={index}
            onClick={() =>
              handleScrollToDomElement(`contents-item-${index + 1}`)
            }
          >
            {content[0]}
          </ContentsListItem>
        ))}
      </ContentsList>
    </Component>
  );
}

export default ListOfContents;

const Component = styled.div`
  display: flex;
  flex-direction: column;
`;

const ContentsList = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-left: 20px;

  &:after {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    content: '';
    width: 4px;
    border-radius: 2px;
    background-color: ${colors.main};
  }
`;

const ContentsListItem = styled.span`
  cursor: pointer;
  font-size: 17px;
  line-height: 24px;
  color: ${(props) => props.theme.black200};
  transition: 0.3s;

  ${media.tablet(css`
    font-size: 14px;
    line-height: 20px;
  `)}

  &:not(:first-child) {
    margin-top: 5px;

    ${media.mobile(css`
      margin-top: 3px;
    `)}
  }

  &:hover {
    color: ${colors.main};
  }

  &:after {
    content: '';
    display: inline-block;
    background-color: transparent;
    width: 12px;
    height: 12px;
    background-position: -1520px -1091px;
    margin-left: 10px;
    margin-bottom: -3px;
    background-size: 2189px 1602px;

    ${media.mobile(css`
      margin-bottom: -4px;
    `)}
  }
`;
